module.exports = __webpack_public_path__ + "static/media/GEST.1131bed4.png";